module.exports = __webpack_public_path__ + "cf3a2e0cd50fcd04c974d943bfff31cc.svg";